import { Injectable } from '@angular/core';
import { RestHttpService } from '@catmodules/core/services/rest-http.service';
import {AircraftRegistration, UserdataFileVersion} from '@catmodules/models/userdata-generation/types';
import { Restangular } from 'ngx-restangular';

@Injectable()
export class UserdataFileVersionService extends RestHttpService<UserdataFileVersion> {

  constructor(service: Restangular) {
    super('userdata-file-versions', service);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/userdata-generation/services/userdata-file-version.service.ts